import { HELPER } from "../helper/helper";

export const SpecialLabelCases = [
  { case: "transactionAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "transactionMerchantAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "transactionChargeAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "transactionTotalAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "maxAllowedDebitAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "maxAllowedSingleDebitAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "totalAllowedDebitAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "maximumAmountPerDebit", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "minimumAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "currentTotalDebitAmount", action: HELPER.TO_CURRENCY_FORMAT },

  { case: "maxAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "successfulDebitAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "expiryDate", action: HELPER.FORMAT_DATE },
  { case: "expiryTime", action: HELPER.FORMAT_DATE },
  { case: "creationDate", action: HELPER.FORMAT_DATE },
  { case: "amount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "flat", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "minimumCap", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "maximumCap", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "theDate", action: HELPER.FORMAT_DATE },
  { case: "transactionTime", action: HELPER.FORMAT_DATE },
  { case: "settlementAttemptDateTime", action: HELPER.FORMAT_DATE },
  { case: "reportTime", action: HELPER.FORMAT_DATE },
  { case: "transactionDate", action: HELPER.FORMAT_DATE },
  { case: "loggedOn", action: HELPER.FORMAT_DATE },
  { case: "tatExpiryDate", action: HELPER.FORMAT_DATE },
  { case: "chargeAmount", action: HELPER.TO_CURRENCY_FORMAT },
  { case: "requestTime", action: HELPER.FORMAT_DATE },
  { case: "responseTime", action: HELPER.FORMAT_DATE },

  { case: "logTime", action: HELPER.FORMAT_DATE },
  { case: "settlementTime", action: HELPER.FORMAT_DATE },
  { case: "responseCode", action: HELPER.RESPONSE_CODE_COLOR },
  { case: "resolutionStatus", action: HELPER.RESPONSE_STATUS },
  { case: "creationStatus", action: HELPER.RESPONSE_STATUS },
  { case: "transactionStatus", action: HELPER.RESPONSE_STATUS },
  { case: "disputeCreationStatus", action: HELPER.RESPONSE_STATUS },
  { case: "reportGenerationStatus", action: HELPER.RESPONSE_STATUS },
  { case: "status", action: HELPER.RESPONSE_STATUS },
  { case: "processStatus", action: HELPER.RESPONSE_STATUS },

  { case: "formattedStatus", action: HELPER.RESPONSE_STATUS },
  { case: "createdOn", action: HELPER.FORMAT_DATE },
  { case: "uploadedAt", action: HELPER.FORMAT_DATE },
  { case: "active", action: HELPER.RESPONSE_STATUS },
  { case: "pending", action: HELPER.RESPONSE_STATUS },
  { case: "failed", action: HELPER.RESPONSE_STATUS },
  { case: "createdAt", action: HELPER.FORMAT_DATE },
  { case: "completedAt", action: HELPER.FORMAT_DATE },
  { case: "createdTime", action: HELPER.FORMAT_DATE },
  { case: "completedTime", action: HELPER.FORMAT_DATE },
  { case: "creationTime", action: HELPER.FORMAT_DATE },
  { case: "percentageProcessed", action: HELPER.PERCENTAGE_STATUS },
  { case: "retentionStatus", action: HELPER.RESPONSE_STATUS },
  { case: "passwordStatus", action: HELPER.RESPONSE_STATUS },
  { case: "requestStatus", action: HELPER.RESPONSE_STATUS },
  { case: "attemptTime", action: HELPER.FORMAT_DATE },
  { case: "uploadTotalCount", action: HELPER.RESPONSE_STATUS },
  { case: "successCount", action: HELPER.RESPONSE_STATUS },
  { case: "failedCount", action: HELPER.RESPONSE_STATUS },
  { case: "transactionType", action: HELPER.RESPONSE_STATUS },
  { case: "lastModifiedOn", action: HELPER.FORMAT_DATE },
  { case: "paymentType", action: HELPER.FORMAT_ENUM },
];

const tokenStorageName = "dd_bo_yhb84sabfy11";
const userNameStorageName = "dd_bo_yhb23szbrb12";
const isLoginStorageName = "dd_bo_lgb84nemjy15";
const expire_inStorageName = "dd_bo_exb84inekm61";
const currentPageStorageName = "dd_bo_cpb84snarm19";
const rolesStorageName = "dd_bo_rub64slesrk17";
const authoritiesStorageName = "dd_bo_aub84sriesrhor08";
const nameStorageName = "dd_bo_rob84slesrm17";
const firstNameStorageName = "dd_bo_firb84srore18";
const lastNameStorageName = "dd_bo_lnb84slagerm23";
const currentPageIndex = "dd_bo_pid14sleverm10";
const merchantIdStorageName = "dd_bo_pid14rdevrrm10";
const merchantNameStorageName = "dd_bo_hyXvgsuTTU123";
const userEmail = "dd_bo_jsu8w_owi82929";
const twoFaKey = "xisipw_jTku_orVzs";

export const LOCAL_STORAGE = {
  TOKEN: `${tokenStorageName}`,
  USER_NAME: `${userNameStorageName}`,
  IS_LOGIN: `${isLoginStorageName}`,
  EXPIRE_IN: `${expire_inStorageName}`,
  CURRENT_PAGE_STORAGE_NAME: `${currentPageStorageName}`,
  ROLES: `${rolesStorageName}`,
  NAME: `${nameStorageName}`,
  FIRST_NAME: `${firstNameStorageName}`,
  LAST_NAME: `${lastNameStorageName}`,
  AUTHORITIES: `${authoritiesStorageName}`,
  CURRENT_PAGE_INDEX: `${currentPageIndex}`,
  MERCHANT_ID: merchantIdStorageName,
  MERCHANT_NAME: merchantNameStorageName,
  USER_EMAIL: userEmail,
  TWO_FA_KEY: twoFaKey,
};
